import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { NavController } from "@ionic/angular";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { MaritalStatusService } from "../../service/marital-status.service";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { RadioModel } from "../../../personal-data/model/radio.model";
import { DomainFactoryService } from "../../../shared/service/domains/domain-factory-service";
import { DomainDataType } from "../../../shared/service/domains/model/domain-data-type";
import { TrackInfo } from "../../../shared/service/journey/tracks/model/track-info";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";

@Component({
  selector: "app-marital-status",
  templateUrl: "./marital-status.page.html",
  styleUrls: ["./marital-status.page.scss"],
})
export class MaritalStatusPageComponent
  extends DefaultPageComponent
  implements OnInit
{
  headerId = "marital-status";
  titlePage = "Estado civil";
  selectedItem = "";
  selectedName = "";
  maritalStatus = [];
  startStage = "";
  endStage = "";
  showRetry = false;
  loading = true;
  dataDomain: RadioModel[];
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  sendAnalyticsFirstView = false;
  idLabelMaritalStatus = "idLabelMaritalLabelStatus";
  idRadioMaritalStatus = "idRadioMaritalStatus";
  idButtonMaritalStatus = "idButtonMaritalStatus";
  constructor(
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public router: NavController,
    public maritalStatusService: MaritalStatusService,
    private title: Title,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    public domainFactory: DomainFactoryService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.configureDomain(null, DomainDataType.MaritalStatus);
    this.getTrack();
  }

  ngOnInit() {
    this.setTitle();
    this.getMaritalStatus();
    this.editFieldInvest("estado_civil", "maritalStatus", "maritalStatus");
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;

    if (
      this.journeyService.journey === TrackTypes.CONTA_ION ||
      this.journeyService.journey === TrackTypes.CONTA_ION_MARITAL
    ) {
      this.startStage = "1";
      this.endStage = "2";
    } else {
      this.startStage = track
        .getIndexPage(this.headerId, this.headerId)
        .toString();
      this.endStage = track.getTotalPage(this.headerId).toString();
    }
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();

    if (this.sendAnalyticsFirstView) {
      this.analyticsData();
      this.sendTrackGA4LoadPage();
    }
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.maritalStatus;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathEstadoCivil,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4LoadPageError() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameAlert,
      custom_path: this.analyticsPageGA4.customPathEstadoCivil,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };
    const paramComplementary = {
      detail: "tipo:tela",
      description: this.analyticsPageGA4.titleError,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl, paramComplementary);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  clickNext() {
    const save =
      this.journeyService.selectedTrack.track.findIndex(
        (page: TrackInfo) => page.pageId === "spouse"
      ) > -1;

    this.sendAnalyticsFirstView = true;
    this.maritalStatusService.setStatusName(
      this.selectedName,
      this.selectedItem,
      save
    );
    this.maritalStatusService.setStatus(this.selectedItem, save);

    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.maritalStatus,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  getPageId(): string {
    return this.headerId;
  }

  getMaritalStatus() {
    this.domainFactory
      .getDomainService(this.domainOrigin)
      .getDomains(this.domainDataType)
      .then((dominios) => {
        if (dominios?.length > 0) {
          this.maritalStatus = dominios;
          this.showRetry = false;
          this.analyticsData();
          this.sendTrackGA4LoadPage();
        } else {
          this.showRetry = true;
          this.headerFocus();
          this.sendTrackGA4LoadPageError();
        }
      })
      .catch(() => {
        this.showRetry = true;
        this.sendTrackGA4LoadPageError();
      })
      .finally(() => {
        this.loading = false;
        this.headerFocus();
      });
  }

  backPage() {
    this.analyticsEventClique();
    if (this.maritalStatusService.maritalStatusPrevious) {
      this.maritalStatusService.setStatusName(
        this.maritalStatusService.maritalStatusNamePrevious,
        this.maritalStatusService.maritalStatusPrevious,
        false
      );
      this.maritalStatusService.setStatus(
        this.maritalStatusService.maritalStatusPrevious,
        false
      );
    }
    setTimeout(() => {
      if (
        this.journeyService.journey === TrackTypes.BASIC_MARITAL_V2 ||
        this.journeyService.journey === TrackTypes.UPDATE_MARITAL
      ) {
        this.router.navigateForward(["data", "client-data"]);
      } else {
        this.back();
      }
    }, 10);
  }

  async setEditPageRegistratio() {
    if (
      this.journeyService.registratioJourney.data.maritalStatus?.maritalStatus
    ) {
      this.selectedItem =
        this.journeyService.registratioJourney.data.maritalStatus.maritalStatus;
      this.selectedName =
        this.journeyService.registratioJourney.data.maritalStatus.maritalStatusName;
    }
  }
}
